import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

export const AppViews = () => {
  const SR = localStorage.getItem('currentuser');
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        {SR.includes('S') ?
          <>
            <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./SR`))} />
            {/* <Route path={`${APP_PREFIX_PATH}/student`} component={lazy(() => import(`./Student`))} /> */}
            <Route path={`${APP_PREFIX_PATH}/student`} component={lazy(() => import(`./StudentSR`))} />
            <Route path={`${APP_PREFIX_PATH}/personal`} component={lazy(() => import(`./Personal`))} />
          </>
          :
          <>
            <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./home`))} />
            <Route path={`${APP_PREFIX_PATH}/student`} component={lazy(() => import(`./Student`))} />
            <Route path={`${APP_PREFIX_PATH}/personal`} component={lazy(() => import(`./Personal`))} />
            {/* <Route path={`${APP_PREFIX_PATH}/wsCheck`} component={lazy(() => import(`./WSCheck`))} /> */}
          </>
        }
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />
      </Switch>
    </Suspense>
  )
}

export default React.memo(AppViews);